import React, { Component } from 'react'
import { Field } from 'formik'
import { InputForm } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import { SmallText } from 'app/common/typography'
import { FormattedMessage, injectIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'
import { Eye, EyeLine } from 'app/assets/icons'
import styled from 'styled-components'

const PASSWORD = 'password'
const TEXT = 'text'

type Props = {
    name: string,
    labelKey: string,
    type: string,
    placeholderKey: string,
    className?: string,
    maxLength?: number,
    intl: IntlShape,
    isPastable?: boolean
}

type State = {
    type: string
}

class PasswordComponent extends Component<Props, State> {
    constructor() {
        super()
        this.state = {
            type: PASSWORD
        }
    }

    togglePassword = (type: string) => {
        this.setState({ type })
    }

    render() {
        const {
            name,
            labelKey,
            placeholderKey,
            className,
            intl,
            maxLength,
            isPastable = true
        } = this.props

        const { type } = this.state
        const onPaste = isPastable ? undefined : e => e.preventDefault()
        return (
            <InputForm className={className}>
                <FormattedMessage id={labelKey}>
                    {(text: string) => (
                        <SmallText color={colors.grey}>{text}</SmallText>
                    )}
                </FormattedMessage>
                <Field
                    name={name}
                    maxLength={maxLength}
                    type={type}
                    placeholder={intl.formatMessage({ id: placeholderKey })}
                    className={className}
                    onPaste={onPaste}
                />
                {type === PASSWORD ? (
                    <IconContainer onClick={() => this.togglePassword(TEXT)}>
                        <Eye />
                    </IconContainer>
                ) : (
                    <IconContainer
                        onClick={() => this.togglePassword(PASSWORD)}>
                        <EyeLine />
                    </IconContainer>
                )}
            </InputForm>
        )
    }
}

const Password = injectIntl(PasswordComponent)

const IconContainer = styled.span`
    position: relative;
    cursor: pointer;
    left: calc(100% - 40px);
    top: -32px;
    height: 0;
`
export { Password }
